"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Link_1 = require("@idp/ui-components/components/atoms/Link");
/** Stylesheets */
var globalStyles = require("../../../styles/att-global.scss");
var styles = require("./SkipAuthentication.scss");
var ReportingService_1 = require("../../../api/ReportingService");
var Events_1 = require("../../../api/Events");
var SkipAuthentication = /** @class */ (function (_super) {
    __extends(SkipAuthentication, _super);
    function SkipAuthentication(props) {
        var _this = _super.call(this, props) || this;
        _this.loginSuccessEvent = 'loginSuccessEvent';
        _this.initializeEvents();
        _this.preventDefault = _this.preventDefault.bind(_this);
        _this.reportingService = new ReportingService_1.default();
        return _this;
    }
    SkipAuthentication.prototype.componentDidMount = function () {
        // console.info( 'componentDidMount' );
        // this.events = new Events( [ this.loginPanelCompleteEvent ] );
        this.events = new Events_1.default([this.loginSuccessEvent]);
        // this.checkForSavedUserId();
        console.log('SKIP_AUTHENTICATION - loginUrl ' + this.props.data.loginUrl);
    };
    SkipAuthentication.prototype.preventDefault = function () {
        // Prevent the default from being triggered for the
        // form element
        event.preventDefault();
    };
    SkipAuthentication.prototype.initializeEvents = function () {
        var _this = this;
        this.skipSignIn = {
            onClick: function () {
                var loginUrl;
                if (_this.props.data && _this.props.data.loginUrl) {
                    loginUrl = _this.props.data.loginUrl;
                }
                else {
                    loginUrl = document.location.href;
                }
                _this.reportingService.fireLinkClickEvent(ReportingService_1.LoginLinkNames.SKIP_AUTHENTICATION, loginUrl);
                _this.events.fireEvent({
                    authenticated: false,
                    cancelled: true,
                }, _this.loginSuccessEvent);
            },
        };
    };
    SkipAuthentication.prototype.render = function () {
        return (React.createElement("div", { className: [styles.skipAuthSection, this.props.options.className].join(' ') },
            React.createElement("div", { className: [globalStyles.formRowMd].join(' '), "data-test-id": this.props.testId },
                React.createElement(Link_1.default, { data: {
                        content: this.props.data.content,
                    }, events: this.skipSignIn }))));
    };
    return SkipAuthentication;
}(React.Component));
exports.default = SkipAuthentication;
//# sourceMappingURL=SkipAuthentication.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/SkipAuthentication/SkipAuthentication.js
// module id = 580
// module chunks = 8